module.exports = __webpack_public_path__ + "static/footer_mobile-408d8ade9994e5308f8d0a9ae4560b91.png";